import { useMemo } from 'react';
import RevenueTopCards from './RevenueTopCards';
import ActualVsForecastRevenueChart from './ActualVsForecastRevenueChart';
import RevenueClientProductivityChart from './RevenueClientProductivityChart';
import BillingTypeRevenueChart from './BillingTypeRevenueChart';

const PerformanceReports = ({ filters }) => {

  const mappedFilters = useMemo(
    () => ({
      clientId: filters.client || '',
      scopeId: filters.scope || '',
      employeeId: filters.user || '',
      startDate: filters.startDate || '',
      endDate: filters.endDate || '',
      monthYear: filters.monthYear || '',
    }),
    [filters]
  );
  return (
    <div className="bg-gray-200 p-6 rounded-lg shadow-lg">
      {/* <h2 className="text-2xl font-bold mb-4">Performance Reports</h2> */}
      {/* <RevenueTabFilter/> */}
      <RevenueTopCards filters={mappedFilters} />
    {/* Charts side-by-side */}
     <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <ActualVsForecastRevenueChart  filters={mappedFilters}/>
        <BillingTypeRevenueChart  filters={mappedFilters}/>
      </div>
      <RevenueClientProductivityChart filters={mappedFilters}/>
    </div>
  );
};

export default PerformanceReports;
